export default "__VITE_ASSET__C7oyDl2o__"